import { Tag } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PageHeader from '../../../shared/components/pageHeader/PageHeader';
import { COMMON_ERROR } from '../../../shared/constants/commonConstants';
import { replyGrievance } from '../../../store/actions/grievanceAction';
import { base64UrlDecoded, centeredNotification } from '../../../utils/utility';
import { STATUS_COLOR_MAP } from '../services/grievanceConstants';
import FileUploadBox from './GetGrievance';
import { GrievanceResponse } from '../../../shared/interfaces/grievanceInterfaces';

const GrievanceDetail = ({ match }: any): ReactElement => {
  const { params: { record } } = match;
  const dispatch = useDispatch();
  const [currRecord, setCurrRecord] = useState<any>(null);
  const [detailConversation, setDetailConversation] = useState<any>(null);
  const [grievanceTransaction, setGrievanceTransaction] = useState<any>(null);

  useEffect((): any => {
    try {
      const selectedRecord = JSON.parse(base64UrlDecoded(record));
      setCurrRecord(selectedRecord);
      const {
        ticketId,
        grievanceTicketId,
        payerId,
        productCode,
        hospactionId,
        hospActionId,
      } = selectedRecord || {};
      const selectedHospActionId = hospactionId || hospActionId;
      const selectedTicketId = ticketId || grievanceTicketId;
      if (selectedHospActionId) {
        const replyGrievanceData = {
          ticketId: selectedTicketId,
          payerId,
          productCode,
          hospactionId: selectedHospActionId,
        };
        dispatch(replyGrievance(replyGrievanceData, onReplySuccess, onReplyError));
      }
    } catch (e) {
      centeredNotification('Incorrect record selected!');
    }
  }, []);

  const onReplySuccess = (result: any, reason: string, grievanceResponse: GrievanceResponse): any => {
    setDetailConversation(result);
    setGrievanceTransaction(grievanceResponse);
  };

  const onReplyError = (error: any): any => {
    centeredNotification(error || COMMON_ERROR);
  };

  return (
    <div>
      <PageHeader
        rightComponent={(): any => null}
        pageTitle={(
          <div>
            Ticket ID - <strong>{(currRecord?.ticketId || currRecord?.grievanceTicketId) || 'Loading...'}</strong>
            <Tag color={STATUS_COLOR_MAP[currRecord?.status]?.color || 'primary'} className="ml-5">
              <strong style={{ color: STATUS_COLOR_MAP[currRecord?.status]?.textColor }}>
                {STATUS_COLOR_MAP[currRecord?.status]?.text}
              </strong>
            </Tag>
          </div>
        )}
        backUrl="/grievance/view"
        isViewGrievancePage={true}
      />
      <div className="scrollable-content">
        <FileUploadBox
          detailConversation={detailConversation}
          currRecord={currRecord}
          grievanceTransaction={grievanceTransaction}
        />
      </div>
    </div>

  );
};
export default GrievanceDetail;
